import httpManager from "@/app/shared/utils/httpManager";

async function parseJsonBlob(blob) {
  if (!(blob instanceof Blob)) return blob;

  try {
    return JSON.parse(await blob.text());
  } catch {
    return blob;
  }
}

function isTxtResponse(response) {
  const contentType = (response?.headers?.["content-type"] || "").toLowerCase();
  const contentDisposition = (response?.headers?.["content-disposition"] || "").toLowerCase();

  return contentType.includes("text/plain") || contentDisposition.includes(".txt");
}

/**
 * Valida un Excel de opciones sin guardar su contenido.
 *
 * @param {number} portfolioId Identificador de la campana.
 * @param {string} fieldName Nombre tecnico del campo.
 * @param {File} file Archivo Excel que contiene las opciones.
 *
 * @return {Promise<Object>} Opciones normalizadas o reporte de validacion.
 */
export async function validateTemplateFieldOptions(portfolioId, fieldName, file) {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await httpManager.upload(
      `/portfolios/${portfolioId}/template/fields/${encodeURIComponent(
        fieldName
      )}/options/validate-excel/`,
      formData,
      { responseType: "blob" }
    );

    if (isTxtResponse(response)) {
      return {
        isTemplateFieldOptionsValidationFile: true,
        response,
      };
    }

    return parseJsonBlob(response?.data);
  } catch (error) {
    if (isTxtResponse(error?.response)) {
      error.isTemplateFieldOptionsValidationFile = true;
      throw error;
    }

    if (error?.response?.data instanceof Blob) {
      error.response.data = await parseJsonBlob(error.response.data);
    }

    throw error;
  }
}
